import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductsSection = ({ onOpenConsultation, onRequestDemo }) => {
  // Interactive PaperLoan Calculator State
  const [loanAmount, setLoanAmount] = useState(5000000);

  const calculateEmi = () => {
    const interestRate = 0.12 / 12; // 12% annual interest
    const tenure = 144; // 12-year / 144 mo tenure formula matching ₹44,424 EMI on ₹50 Lakhs
    const emi = (loanAmount * interestRate * Math.pow(1 + interestRate, tenure)) / (Math.pow(1 + interestRate, tenure) - 1);
    return Math.round(emi || 44424);
  };

  return (
    <section
      id="products"
      style={{
        padding: '60px 0 70px 0',
        position: 'relative',
        zIndex: 2,
        background: '#040612',
        color: '#FFFFFF',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      {/* Background Ambient Glows */}
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '15%',
          width: '350px',
          height: '350px',
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.12) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '15%',
          right: '15%',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />

      <div className="ht-container" style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '44px' }}>
          {/* Top Pill Tag */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 16px',
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              fontSize: '0.72rem',
              fontWeight: 700,
              letterSpacing: '1.2px',
              color: '#D8B4FE',
              marginBottom: '16px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            }}
          >
            <span style={{ fontSize: '0.65rem', color: '#A78BFA' }}>✦</span>
            <span>BUILT FOR IMPACT</span>
            <span style={{ fontSize: '0.65rem', color: '#A78BFA' }}>✦</span>
          </div>

          {/* Heading */}
          <h2
            style={{
              fontSize: 'clamp(2.1rem, 4vw, 3rem)',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              margin: '0 0 12px 0',
              lineHeight: 1.15,
            }}
          >
            <span style={{ color: '#FFFFFF' }}>Innovative Products </span>
            <span
              style={{
                background: 'linear-gradient(90deg, #A78BFA 0%, #38BDF8 50%, #818CF8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Built for the Future
            </span>
          </h2>

          {/* Subtitle */}
          <p
            style={{
              color: '#94A3B8',
              fontSize: '0.96rem',
              maxWidth: '650px',
              margin: '0 auto',
              lineHeight: 1.5,
              fontWeight: 400,
            }}
          >
            Proprietary enterprise SaaS platforms powering digital lending, restaurant commerce, AI social growth, and project analytics.
          </p>
        </div>

        {/* 2x2 Product Grid */}
        <div
          className="products-main-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '22px',
            marginBottom: '24px',
          }}
        >
          {/* ======================================================== */}
          {/* CARD 1: PaperLoan (Fintech Engine) */}
          {/* ======================================================== */}
          <div
            className="product-card-hover"
            style={{
              background: 'linear-gradient(145deg, rgba(15, 17, 36, 0.9) 0%, rgba(9, 11, 25, 0.95) 100%)',
              borderRadius: '20px',
              border: '1px solid rgba(139, 92, 246, 0.35)',
              padding: '24px',
              boxShadow: '0 16px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(139, 92, 246, 0.12)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Top Glow Accent Line */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                background: 'linear-gradient(90deg, transparent 0%, #A78BFA 50%, transparent 100%)',
              }}
            />

            <div>
              {/* Header Row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {/* Icon */}
                  <div
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFF',
                      boxShadow: '0 0 16px rgba(168, 85, 247, 0.45)',
                      flexShrink: 0,
                    }}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#FFFFFF', margin: 0, lineHeight: 1.15 }}>
                      PaperLoan
                    </h3>
                    <span style={{ fontSize: '0.74rem', color: '#C084FC', fontWeight: 700 }}>
                      AI Digital Lending Platform
                    </span>
                  </div>
                </div>

                {/* Tag Pill */}
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    border: '1px solid rgba(168, 85, 247, 0.5)',
                    background: 'rgba(168, 85, 247, 0.12)',
                    color: '#E9D5FF',
                    fontSize: '0.62rem',
                    fontWeight: 800,
                    letterSpacing: '0.8px',
                  }}
                >
                  FINTECH ENGINE
                </span>
              </div>

              {/* Card Internal 2-Column Content */}
              <div className="card-content-inner" style={{ display: 'grid', gridTemplateColumns: '1.05fr 1fr', gap: '16px', alignItems: 'stretch', marginBottom: '20px' }}>
                {/* Left Description & Checkmarks */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <p style={{ fontSize: '0.8rem', color: '#94A3B8', lineHeight: 1.45, margin: '0 0 14px 0' }}>
                    Enterprise digital lending software for NBFCs & banks. Automates credit underwriting, loan origination, eKYC verification, and repayments.
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Instant Underwriting AI',
                      'Loan Origination Engine',
                      'Automated eKYC & Video',
                      'Automated Repayments',
                    ].map((feat, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div
                          style={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            background: 'rgba(168, 85, 247, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#C084FC',
                            flexShrink: 0,
                          }}
                        >
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <span style={{ fontSize: '0.76rem', color: '#CBD5E1', fontWeight: 600 }}>{feat}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Interactive Disbursal Simulator Widget */}
                <div
                  style={{
                    background: 'rgba(6, 8, 20, 0.95)',
                    borderRadius: '14px',
                    border: '1px solid rgba(139, 92, 246, 0.25)',
                    padding: '14px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <span style={{ fontSize: '0.78rem', color: '#FFFFFF', fontWeight: 700 }}>Disbursal Simulator</span>
                  </div>

                  <div style={{ marginBottom: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '6px' }}>
                      <span style={{ fontSize: '0.68rem', color: '#94A3B8' }}>Loan Amount</span>
                      <span style={{ fontSize: '0.92rem', color: '#FFFFFF', fontWeight: 800 }}>
                        ₹{loanAmount.toLocaleString('en-IN')}
                      </span>
                    </div>

                    {/* Styled Range Slider */}
                    <input
                      type="range"
                      min="500000"
                      max="10000000"
                      step="250000"
                      value={loanAmount}
                      onChange={(e) => setLoanAmount(Number(e.target.value))}
                      style={{
                        width: '100%',
                        accentColor: '#A78BFA',
                        cursor: 'pointer',
                        height: '4px',
                        borderRadius: '2px',
                        background: 'rgba(168, 85, 247, 0.3)',
                      }}
                    />
                  </div>

                  {/* EMI Box */}
                  <div
                    style={{
                      background: 'rgba(168, 85, 247, 0.08)',
                      border: '1px solid rgba(168, 85, 247, 0.2)',
                      borderRadius: '10px',
                      padding: '8px 10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <div style={{ fontSize: '0.64rem', color: '#94A3B8' }}>Est. Monthly EMI</div>
                      <div style={{ fontSize: '0.96rem', color: '#FFFFFF', fontWeight: 800 }}>
                        ₹{calculateEmi().toLocaleString('en-IN')}{' '}
                        <span style={{ fontSize: '0.68rem', color: '#94A3B8', fontWeight: 500 }}>/mo</span>
                      </div>
                    </div>
                    <div
                      style={{
                        background: 'rgba(52, 211, 153, 0.15)',
                        color: '#34D399',
                        fontSize: '0.64rem',
                        fontWeight: 700,
                        padding: '3px 7px',
                        borderRadius: '6px',
                        textAlign: 'right',
                      }}
                    >
                      + 12.4%<br />
                      <span style={{ fontSize: '0.58rem', color: '#94A3B8', fontWeight: 500 }}>vs last month</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Actions */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '8px' }}>
              <button
                onClick={() => onRequestDemo('PaperLoan')}
                style={{
                  background: 'linear-gradient(90deg, #7C3AED 0%, #6366F1 100%)',
                  boxShadow: '0 4px 18px rgba(124, 58, 237, 0.35)',
                  border: 'none',
                  borderRadius: '30px',
                  color: '#FFFFFF',
                  padding: '9px 20px',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
              >
                <span>Explore PaperLoan</span>
                <span style={{ fontSize: '0.9rem' }}>→</span>
              </button>

              <button
                onClick={onOpenConsultation}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                }}
              >
                <span>Learn More</span>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                  }}
                >
                  ➔
                </div>
              </button>
            </div>
          </div>

          {/* ======================================================== */}
          {/* CARD 2: HungryTop (Marketplace) */}
          {/* ======================================================== */}
          <div
            className="product-card-hover"
            style={{
              background: 'linear-gradient(145deg, rgba(11, 22, 38, 0.9) 0%, rgba(6, 13, 25, 0.95) 100%)',
              borderRadius: '20px',
              border: '1px solid rgba(14, 165, 233, 0.35)',
              padding: '24px',
              boxShadow: '0 16px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(14, 165, 233, 0.12)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Top Glow Accent Line */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                background: 'linear-gradient(90deg, transparent 0%, #38BDF8 50%, transparent 100%)',
              }}
            />

            <div>
              {/* Header Row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {/* Icon */}
                  <div
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #0284C7 0%, #38BDF8 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFF',
                      boxShadow: '0 0 16px rgba(56, 189, 248, 0.45)',
                      flexShrink: 0,
                    }}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                      <line x1="6" y1="1" x2="6" y2="4"></line>
                      <line x1="10" y1="1" x2="10" y2="4"></line>
                      <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#FFFFFF', margin: 0, lineHeight: 1.15 }}>
                      HungryTop
                    </h3>
                    <span style={{ fontSize: '0.74rem', color: '#38BDF8', fontWeight: 700 }}>
                      Food Auction & Restaurant SaaS
                    </span>
                  </div>
                </div>

                {/* Tag Pill */}
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    border: '1px solid rgba(56, 189, 248, 0.5)',
                    background: 'rgba(56, 189, 248, 0.12)',
                    color: '#BAE6FD',
                    fontSize: '0.62rem',
                    fontWeight: 800,
                    letterSpacing: '0.8px',
                  }}
                >
                  MARKETPLACE
                </span>
              </div>

              {/* Card Internal 2-Column Content */}
              <div className="card-content-inner" style={{ display: 'grid', gridTemplateColumns: '1.05fr 1fr', gap: '16px', alignItems: 'stretch', marginBottom: '20px' }}>
                {/* Left Description & Checkmarks */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <p style={{ fontSize: '0.8rem', color: '#94A3B8', lineHeight: 1.45, margin: '0 0 14px 0' }}>
                    Complete SaaS platform for restaurant networks, cloud kitchens, and food marketplaces featuring live auctions, ordering, & rider tracking.
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Food Auction Bidding Engine',
                      'Real-Time Rider GPS Track',
                      'POS & Kitchen Display Sync',
                      'Instant Merchant Settlement',
                    ].map((feat, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div
                          style={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            background: 'rgba(56, 189, 248, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#38BDF8',
                            flexShrink: 0,
                          }}
                        >
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <span style={{ fontSize: '0.76rem', color: '#CBD5E1', fontWeight: 600 }}>{feat}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Image & Bidding Engine Mockup Widget */}
                <div
                  style={{
                    position: 'relative',
                    borderRadius: '14px',
                    overflow: 'hidden',
                    border: '1px solid rgba(56, 189, 248, 0.3)',
                    minHeight: '145px',
                    background: '#0B132B',
                  }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=80"
                    alt="HungryTop Restaurant Network"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      filter: 'brightness(0.65) contrast(1.1)',
                      display: 'block',
                    }}
                  />
                  {/* Top-Right Badge Overlay */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      background: 'rgba(6, 10, 25, 0.85)',
                      backdropFilter: 'blur(6px)',
                      padding: '3px 8px',
                      borderRadius: '10px',
                      border: '1px solid rgba(56, 189, 248, 0.3)',
                      fontSize: '0.6rem',
                      color: '#38BDF8',
                      fontWeight: 700,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#34D399' }} />
                    1,420+ Live Merchants
                  </div>

                  {/* Bottom Left Label */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '8px',
                      left: '8px',
                      background: 'rgba(6, 10, 25, 0.85)',
                      backdropFilter: 'blur(6px)',
                      padding: '4px 8px',
                      borderRadius: '8px',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      fontSize: '0.62rem',
                      color: '#FFFFFF',
                      fontWeight: 700,
                    }}
                  >
                    Food Auction Bidding Engine
                  </div>

                  {/* Bottom Right Wave Graph Graphic */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '8px',
                      right: '8px',
                      width: '80px',
                      height: '32px',
                    }}
                  >
                    <svg width="100%" height="100%" viewBox="0 0 100 40" fill="none">
                      <path
                        d="M0 30 Q 20 10, 40 25 T 80 15 T 100 5 L 100 40 L 0 40 Z"
                        fill="rgba(56, 189, 248, 0.25)"
                      />
                      <path
                        d="M0 30 Q 20 10, 40 25 T 80 15 T 100 5"
                        stroke="#38BDF8"
                        strokeWidth="2.5"
                        fill="none"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Actions */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '8px' }}>
              <Link
                to="/products/hungrytop"
                style={{
                  background: 'linear-gradient(90deg, #0284C7 0%, #2563EB 100%)',
                  boxShadow: '0 4px 18px rgba(2, 132, 199, 0.35)',
                  border: 'none',
                  borderRadius: '30px',
                  color: '#FFFFFF',
                  padding: '9px 20px',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
              >
                <span>Explore HungryTop</span>
                <span style={{ fontSize: '0.9rem' }}>→</span>
              </Link>

              <button
                onClick={onOpenConsultation}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                }}
              >
                <span>Learn More</span>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                  }}
                >
                  ➔
                </div>
              </button>
            </div>
          </div>

          {/* ======================================================== */}
          {/* CARD 3: SocialSphere AI (Auto-Pilot) */}
          {/* ======================================================== */}
          <div
            className="product-card-hover"
            style={{
              background: 'linear-gradient(145deg, rgba(28, 12, 28, 0.9) 0%, rgba(13, 6, 20, 0.95) 100%)',
              borderRadius: '20px',
              border: '1px solid rgba(236, 72, 153, 0.35)',
              padding: '24px',
              boxShadow: '0 16px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(236, 72, 153, 0.12)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Top Glow Accent Line */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                background: 'linear-gradient(90deg, transparent 0%, #F472B6 50%, transparent 100%)',
              }}
            />

            <div>
              {/* Header Row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {/* Icon */}
                  <div
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #DB2777 0%, #F472B6 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFF',
                      boxShadow: '0 0 16px rgba(244, 114, 182, 0.45)',
                      flexShrink: 0,
                    }}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="18" cy="5" r="3"></circle>
                      <circle cx="6" cy="12" r="3"></circle>
                      <circle cx="18" cy="19" r="3"></circle>
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#FFFFFF', margin: 0, lineHeight: 1.15 }}>
                      SocialSphere AI
                    </h3>
                    <span style={{ fontSize: '0.74rem', color: '#F472B6', fontWeight: 700 }}>
                      Autonomous Social Growth Suite
                    </span>
                  </div>
                </div>

                {/* Tag Pill */}
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    border: '1px solid rgba(244, 114, 182, 0.5)',
                    background: 'rgba(244, 114, 182, 0.12)',
                    color: '#FBCFE8',
                    fontSize: '0.62rem',
                    fontWeight: 800,
                    letterSpacing: '0.8px',
                  }}
                >
                  AUTO-PILOT
                </span>
              </div>

              {/* Card Internal 2-Column Content */}
              <div className="card-content-inner" style={{ display: 'grid', gridTemplateColumns: '1.05fr 1fr', gap: '16px', alignItems: 'stretch', marginBottom: '20px' }}>
                {/* Left Description & Checkmarks */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <p style={{ fontSize: '0.8rem', color: '#94A3B8', lineHeight: 1.45, margin: '0 0 14px 0' }}>
                    Next-gen AI automation suite for social media. Auto-generates content, viral graphics, schedules posts, and automates DM responses.
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'AI Copywriting & Graphics',
                      'Multi-Platform Auto-Scheduler',
                      'Brand Sentiment & Trend Radar',
                      'Smart DM & Comment Bots',
                    ].map((feat, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div
                          style={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            background: 'rgba(244, 114, 182, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#F472B6',
                            flexShrink: 0,
                          }}
                        >
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <span style={{ fontSize: '0.76rem', color: '#CBD5E1', fontWeight: 600 }}>{feat}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Social Grid & Metrics Widget */}
                <div
                  style={{
                    background: 'rgba(6, 8, 20, 0.95)',
                    borderRadius: '14px',
                    border: '1px solid rgba(236, 72, 153, 0.25)',
                    padding: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  {/* Social Platform Icons Grid */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '10px' }}>
                    {/* Instagram */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: 'linear-gradient(45deg, #F09433 0%, #E6683C 25%, #DC2743 50%, #CC2366 75%, #BC1888 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFF',
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                      </svg>
                    </div>
                    {/* X / Twitter */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: '#000000',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFF',
                        fontWeight: 900,
                        fontSize: '0.85rem',
                      }}
                    >
                      ✕
                    </div>
                    {/* LinkedIn */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: '#0A66C2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFF',
                        fontWeight: 800,
                        fontSize: '0.82rem',
                      }}
                    >
                      in
                    </div>
                    {/* Facebook */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: '#1877F2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFF',
                        fontWeight: 800,
                        fontSize: '0.9rem',
                      }}
                    >
                      f
                    </div>
                    {/* YouTube */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: '#FF0000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#FFF',
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                      </svg>
                    </div>
                    {/* TikTok */}
                    <div
                      style={{
                        height: '32px',
                        borderRadius: '8px',
                        background: '#010101',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#25F4EE',
                        fontWeight: 800,
                        fontSize: '0.78rem',
                      }}
                    >
                      ♪
                    </div>
                  </div>

                  {/* Reach & Accuracy Metrics */}
                  <div
                    style={{
                      background: 'rgba(236, 72, 153, 0.08)',
                      border: '1px solid rgba(236, 72, 153, 0.2)',
                      borderRadius: '10px',
                      padding: '8px 10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <div style={{ fontSize: '0.95rem', color: '#FFFFFF', fontWeight: 800, lineHeight: 1 }}>50M+</div>
                      <div style={{ fontSize: '0.62rem', color: '#94A3B8' }}>Reach Generated</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '0.74rem', color: '#F472B6', fontWeight: 800 }}>+ 95.4%</div>
                      <div style={{ fontSize: '0.58rem', color: '#94A3B8' }}>AI Accuracy</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Actions */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '8px' }}>
              <button
                onClick={() => onRequestDemo('SocialSphere AI')}
                style={{
                  background: 'linear-gradient(90deg, #E11D48 0%, #DB2777 100%)',
                  boxShadow: '0 4px 18px rgba(225, 29, 72, 0.35)',
                  border: 'none',
                  borderRadius: '30px',
                  color: '#FFFFFF',
                  padding: '9px 20px',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
              >
                <span>Explore SocialSphere AI</span>
                <span style={{ fontSize: '0.9rem' }}>→</span>
              </button>

              <button
                onClick={onOpenConsultation}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                }}
              >
                <span>Learn More</span>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                  }}
                >
                  ➔
                </div>
              </button>
            </div>
          </div>

          {/* ======================================================== */}
          {/* CARD 4: ApexAnalytics AI (Velocity AI) */}
          {/* ======================================================== */}
          <div
            className="product-card-hover"
            style={{
              background: 'linear-gradient(145deg, rgba(8, 24, 20, 0.9) 0%, rgba(4, 14, 12, 0.95) 100%)',
              borderRadius: '20px',
              border: '1px solid rgba(16, 185, 129, 0.35)',
              padding: '24px',
              boxShadow: '0 16px 40px rgba(0, 0, 0, 0.5), 0 0 25px rgba(16, 185, 129, 0.12)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Top Glow Accent Line */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                background: 'linear-gradient(90deg, transparent 0%, #34D399 50%, transparent 100%)',
              }}
            />

            <div>
              {/* Header Row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {/* Icon */}
                  <div
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #059669 0%, #34D399 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFF',
                      boxShadow: '0 0 16px rgba(52, 211, 153, 0.45)',
                      flexShrink: 0,
                    }}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                      <polyline points="17 6 23 6 23 12"></polyline>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#FFFFFF', margin: 0, lineHeight: 1.15 }}>
                      ApexAnalytics AI
                    </h3>
                    <span style={{ fontSize: '0.74rem', color: '#34D399', fontWeight: 700 }}>
                      Predictive Project Intelligence
                    </span>
                  </div>
                </div>

                {/* Tag Pill */}
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: '12px',
                    border: '1px solid rgba(52, 211, 153, 0.5)',
                    background: 'rgba(52, 211, 153, 0.12)',
                    color: '#A7F3D0',
                    fontSize: '0.62rem',
                    fontWeight: 800,
                    letterSpacing: '0.8px',
                  }}
                >
                  VELOCITY AI
                </span>
              </div>

              {/* Card Internal 2-Column Content */}
              <div className="card-content-inner" style={{ display: 'grid', gridTemplateColumns: '1.05fr 1fr', gap: '16px', alignItems: 'stretch', marginBottom: '20px' }}>
                {/* Left Description & Checkmarks */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <p style={{ fontSize: '0.8rem', color: '#94A3B8', lineHeight: 1.45, margin: '0 0 14px 0' }}>
                    Predictive project analytics platform for engineering teams. Forecasts delays, monitors sprint velocity, and automates reporting.
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      'Predictive Velocity & Risk AI',
                      'Real-Time Sprint Telemetry',
                      'Automated Resource Allocation',
                      'Jira, GitHub & GitLab Sync',
                    ].map((feat, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div
                          style={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            background: 'rgba(52, 211, 153, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#34D399',
                            flexShrink: 0,
                          }}
                        >
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <span style={{ fontSize: '0.76rem', color: '#CBD5E1', fontWeight: 600 }}>{feat}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Project Health & Sprint Bar Chart Widget */}
                <div
                  style={{
                    background: 'rgba(6, 8, 20, 0.95)',
                    borderRadius: '14px',
                    border: '1px solid rgba(16, 185, 129, 0.25)',
                    padding: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ fontSize: '0.66rem', color: '#94A3B8', fontWeight: 600, marginBottom: '6px' }}>
                    Project Health
                  </div>

                  {/* Donut Gauge & Trend Line Row */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                    {/* Ring Progress */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ position: 'relative', width: '38px', height: '38px' }}>
                        <svg width="38" height="38" viewBox="0 0 36 36">
                          <path
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none"
                            stroke="rgba(255, 255, 255, 0.1)"
                            strokeWidth="3"
                          />
                          <path
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none"
                            stroke="#10B981"
                            strokeWidth="3"
                            strokeDasharray="57, 100"
                          />
                        </svg>
                      </div>
                      <div>
                        <div style={{ fontSize: '0.85rem', color: '#FFFFFF', fontWeight: 800 }}>57.1%</div>
                        <div style={{ fontSize: '0.58rem', color: '#34D399', fontWeight: 600 }}>On Track</div>
                      </div>
                    </div>

                    {/* Wave Trend SVG */}
                    <div style={{ width: '50px', height: '24px' }}>
                      <svg width="100%" height="100%" viewBox="0 0 50 20">
                        <path d="M0 15 L 12 10 L 24 16 L 36 6 L 50 12" stroke="#34D399" strokeWidth="2" fill="none" />
                      </svg>
                    </div>
                  </div>

                  {/* 5-Bar Sprint Chart */}
                  <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', height: '36px', gap: '4px' }}>
                    {[
                      { week: 'W1', h: '40%' },
                      { week: 'W2', h: '65%' },
                      { week: 'W3', h: '50%' },
                      { week: 'W4', h: '85%' },
                      { week: 'W5', h: '100%' },
                    ].map((bar, i) => (
                      <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' }}>
                        <div
                          style={{
                            width: '100%',
                            height: bar.h,
                            background: 'linear-gradient(180deg, #34D399 0%, #059669 100%)',
                            borderRadius: '3px 3px 0 0',
                          }}
                        />
                        <span style={{ fontSize: '0.55rem', color: '#64748B', marginTop: '2px' }}>{bar.week}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Actions */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '8px' }}>
              <button
                onClick={() => onRequestDemo('ApexAnalytics AI')}
                style={{
                  background: 'linear-gradient(90deg, #059669 0%, #10B981 100%)',
                  boxShadow: '0 4px 18px rgba(16, 185, 129, 0.35)',
                  border: 'none',
                  borderRadius: '30px',
                  color: '#FFFFFF',
                  padding: '9px 20px',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
              >
                <span>Explore ApexAnalytics AI</span>
                <span style={{ fontSize: '0.9rem' }}>→</span>
              </button>

              <button
                onClick={onOpenConsultation}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                }}
              >
                <span>Learn More</span>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                  }}
                >
                  ➔
                </div>
              </button>
            </div>
          </div>

        </div>

        {/* ======================================================== */}
        {/* BOTTOM STATS BAR */}
        {/* ======================================================== */}
        <div
          className="bottom-stats-banner"
          style={{
            background: 'linear-gradient(145deg, rgba(13, 17, 38, 0.75) 0%, rgba(8, 11, 24, 0.85) 100%)',
            borderRadius: '18px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '18px 24px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          {/* Stat 1: Enterprise Products */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div
              style={{
                width: '42px',
                height: '42px',
                borderRadius: '50%',
                background: 'rgba(168, 85, 247, 0.15)',
                border: '1px solid rgba(168, 85, 247, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#C084FC',
                flexShrink: 0,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.71.79-1.81.79-1.81l-3-3s-1.1.08-1.79.79z"></path>
                <path d="M15 9l-6 6"></path>
                <path d="M9 15l-3-3 7.64-7.64a2.76 2.76 0 0 1 3.9 3.9L9.9 15.9z"></path>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF', lineHeight: 1.2 }}>
                4+ <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#E2E8F0' }}>Enterprise Products</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: '#94A3B8', marginTop: '2px' }}>Built for scale & impact</div>
            </div>
          </div>

          {/* Stat 2: Active Businesses */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div
              style={{
                width: '42px',
                height: '42px',
                borderRadius: '50%',
                background: 'rgba(99, 102, 241, 0.15)',
                border: '1px solid rgba(99, 102, 241, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#818CF8',
                flexShrink: 0,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF', lineHeight: 1.2 }}>
                10K+ <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#E2E8F0' }}>Active Businesses</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: '#94A3B8', marginTop: '2px' }}>Across 25+ countries</div>
            </div>
          </div>

          {/* Stat 3: Uptime SLA */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div
              style={{
                width: '42px',
                height: '42px',
                borderRadius: '50%',
                background: 'rgba(56, 189, 248, 0.15)',
                border: '1px solid rgba(56, 189, 248, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#38BDF8',
                flexShrink: 0,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF', lineHeight: 1.2 }}>
                99.9% <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#E2E8F0' }}>Uptime SLA</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: '#94A3B8', marginTop: '2px' }}>Enterprise reliability</div>
            </div>
          </div>

          {/* Stat 4: Security */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div
              style={{
                width: '42px',
                height: '42px',
                borderRadius: '50%',
                background: 'rgba(52, 211, 153, 0.15)',
                border: '1px solid rgba(52, 211, 153, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#34D399',
                flexShrink: 0,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF', lineHeight: 1.2 }}>
                Enterprise <span style={{ fontSize: '0.82rem', fontWeight: 700, color: '#E2E8F0' }}>Grade Security</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: '#94A3B8', marginTop: '2px' }}>Bank-grade protection</div>
            </div>
          </div>
        </div>

      </div>

      {/* Embedded CSS for responsive scaling */}
      <style>{`
        .product-card-hover {
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
        }
        .product-card-hover:hover {
          transform: translateY(-4px);
        }
        @media (max-width: 1024px) {
          .products-main-grid {
            grid-template-columns: 1fr !important;
          }
          .bottom-stats-banner {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 20px !important;
          }
        }
        @media (max-width: 640px) {
          .card-content-inner {
            grid-template-columns: 1fr !important;
          }
          .bottom-stats-banner {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ProductsSection;
